import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import { ErrorMessages } from "../../../Global/Messages/Messages";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import TeamFormFilters from "../Models/TeamForm/TeamFormFilters";

export default class FootballArgumentsValidator extends BaseValidator {
  readonly limit = 50;

  constructor(config: SDKConfigurationModel) {
    super(config.errorHandlingMode);
  }

  public validateTeamFormArguments = (
    teamId: string,
    filters?: TeamFormFilters
  ) => {
    if (!teamId || typeof teamId !== "string") {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_TEAM_ID,
        ErrorMessages.INVALID_TEAM_ID
      );
    }

    if (filters) {
      if (filters.competitionId && typeof filters.competitionId !== "string") {
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_COMPETITION_ID,
          ErrorMessages.INVALID_COMPETITION_ID
        );
      }

      if (filters.limit && typeof filters.limit !== "number") {
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_LIMIT,
          ErrorMessages.INVALID_LIMIT_TYPE
        );
      }

      if (filters.limit && filters.limit > this.limit) {
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_LIMIT,
          ErrorMessages.INVALID_LIMIT + this.limit.toString()
        );
      }
    }
  };
}
